import { PowerReviewsInitializedUseCase } from '~use-cases/PowerReviewsInitializedUseCase';
import { ReadReviewsClickedUseCase } from '~use-cases/ReadReviewsClickedUseCase';
import { WriteReviewClickedUseCase } from '~use-cases/WriteReviewClickedUseCase';
import { ProductFullLoadedUseCase } from '~use-cases/ProductFullLoadedUseCase';
import { UpdateReviewConfigUseCase } from '~use-cases/UpdateReviewConfigUseCase';
import { IReviewUpdateConfig } from '../internal/interfaces/IReviewUpdateConfig';
import { IReviewsPayload } from '~interfaces/IReviews';
import { RatingsRepository } from '~repositories/RatingsRepository';

interface IProductFullLoaded {
    productId: string;
    skuId: string;
}
export class ServiceBusController {
    private ratingsRepository: RatingsRepository;

    constructor(ratingsRepository: RatingsRepository) {
        this.ratingsRepository = ratingsRepository;
    }

    public powerReviewsInitialized = async (productId: string) => {
        const powerReviewsInitializedUseCase = new PowerReviewsInitializedUseCase(productId);
        await powerReviewsInitializedUseCase.execute();
    };

    public readReviewsLinkClicked = () => {
        const readReviewsLinkClickedUseCase = new ReadReviewsClickedUseCase();
        readReviewsLinkClickedUseCase.execute();
    };

    public writeReviewsLinkClicked = (reviewInfo: IReviewsPayload) => {
        const writeReviewsLinkClickedUseCase = new WriteReviewClickedUseCase(reviewInfo);
        writeReviewsLinkClickedUseCase.execute();
    };

    public productFullLoaded = ({ productId, skuId }: IProductFullLoaded) => {
        const productFullLoadedUseCase = new ProductFullLoadedUseCase(productId, skuId);
        productFullLoadedUseCase.execute();
    };

    public updateReviewConfig = async (config: IReviewUpdateConfig) => {
        const updateReviewConfigUseCase = new UpdateReviewConfigUseCase(config);
        await updateReviewConfigUseCase.execute();
    };

    public getReviewSnippets = async (pageIds: string[]) => {
        return this.ratingsRepository.getProductsRating(pageIds);
    };
}
